import Insights from "../models/Insights";

const InsightsStore = Insights.create();

export default InsightsStore;